import { FSOperation } from '@/sharedModules/database/DatabaseInterface';
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  deleteDoc,
  FieldValue,
} from 'firebase/firestore';

export async function executeClientDatabase(operation: FSOperation) {
  if (!navigator.onLine) {
    console.log('Skipping operation because device is offline');
    return;
  }

  const db = getFirestore();

  switch (operation.operation) {
    case 'read': {
      const docRef = doc(db, operation.docPath);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const result = operation.propertiesPath.reduce(
          (acc: Record<string, any>, key: string) => {
            acc[key] = docSnap.get(key);
            return acc;
          },
          {},
        );
        console.log('Document data:', result);
        return result;
      } else {
        console.log('No such document!');
      }
      break;
    }

    case 'create': {
      const docRef = doc(db, operation.docPath);
      await setDoc(docRef, operation.data);
      console.log('Document created');
      break;
    }

    case 'set': {
      const docRef = doc(db, operation.docPath);
      await setDoc(docRef, operation.data, { merge: false });
      console.log('Document set');
      break;
    }

    case 'set_with_merge': {
      const docRef = doc(db, operation.docPath);
      await setDoc(docRef, operation.data, { merge: true });
      console.log('Document set with merge');
      break;
    }

    case 'update': {
      const docRef = doc(db, operation.docPath);
      await updateDoc(
        docRef,
        operation.data as {
          [x: string]: FieldValue | Partial<unknown> | undefined;
        },
      );
      console.log('Document updated');
      break;
    }

    case 'delete': {
      const docRef = doc(db, operation.docPath);
      await deleteDoc(docRef);
      console.log('Document deleted');
      break;
    }

    case 'no_op': {
      console.log('Document left untouched');
      break;
    }

    default:
      console.error('Unsupported operation');
  }
}
